import React from 'react'

const HourglassIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26 4H24V7.91229C24 10.173 22.9082 12.2944 21.0687 13.6084L17.7205 16L21.0687 18.3916C22.9082 19.7056 24 21.827 24 24.0877V28H26V30H6V28H8L8 24.0877C8 21.827 9.09176 19.7056 10.9313 18.3916L14.2795 16L10.9313 13.6084C9.09176 12.2944 8 10.173 8 7.91229V4H6V2H26V4ZM10 28L22 28V24.0877C22 22.473 21.2202 20.9576 19.9062 20.019L16 17.2289L12.0938 20.019C10.7798 20.9576 10 22.473 10 24.0877L10 28ZM10 4H22V7.91229C22 7.94156 21.9997 7.9708 21.9992 8H10.0008C10.0003 7.9708 10 7.94156 10 7.91229V4Z'
        fill='#575761'
      />
    </svg>
  )
}

export default HourglassIcon
